import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { UpdateExternalDataResponse } from '../domain/entities'
import { ExternalDataRepository } from '../domain/external-data.repository'

export const odinNebulaExternalDataRepository: ExternalDataRepository = {
  updateExternalData: async ({ jobUuid, backofficeData }) => {
    const request: HttpRequest = {
      method: 'PUT',
      endpoint: `/nebula/jobs/${jobUuid}/external-data`,
      body: { external_data: { backoffice: backofficeData } }
    }
    let result: any
    try {
      result = await AvtGateway.executePutRequest(request)
    } catch (error) {
      return error
    }
    const response: UpdateExternalDataResponse = {
      updated: result.status === 200 ? true : false,
      message: await result.text()
    }
    return response
  }
}
